import { shade } from 'polished';
import styled from 'styled-components';
import { ButtonConfirm } from '../../components/ButtonConfirm';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 460px;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  padding: 28px;
`;

export const IconRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 48px;
  height: 48px;
  border-radius: ${radius.full};

  background-color: ${colors.error}26;
`;

export const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const Text = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 8px;

  span {
    font-weight: 700;
    color: ${colors.onSurface};
  }

  span.danger {
    color: ${colors.error};
  }
`;

export const ConfirmInput = styled.input`
  width: 100%;
  height: 48px;
  margin-top: 16px;

  padding: 0 16px;

  background-color: ${colors.surfaceContainerHigh};
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  outline: none;

  color: ${colors.onSurface};
  font-size: 14px;

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }

  &:focus {
    border-color: ${colors.error};
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const Cancel = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const Button = styled(ButtonConfirm)`
  width: auto;
  height: 44px;
  padding: 0 24px;
  border-radius: ${radius.DEFAULT};

  background-color: ${colors.error};

  &:hover {
    background-color: ${shade(0.2, colors.error)};
  }

  &:disabled {
    background-color: ${colors.error}50;
  }
`;
